import React from "react";

const StampsTemplate = ({
  stampsselected: numberOfStamps,
  pickImg,
  pickunImg,
  stampedBackground: colorStamps,
  unstampedBackground: colorunStamps,
  stampCount,
  stampSize = 30, // default to 30px if not provided
  bonusList = [], // <-- receive bonusList
}) => {
  // const [bonus1, bonus2, bonus3, bonus4] = bonusList;

  const bonus1 = "10% off";
  const bonus2 = "1 free";
  const bonus3 = "20% off";
  const bonus4 = "2 free";

  const dynamicStampSize =
    numberOfStamps > 16 ? 22 : numberOfStamps > 12 ? 24 : 30;
  const stampsPerRow = numberOfStamps > 10 ? 4 : 5;

  const renderStamp = (i, filled, showBonus, bonusText) => {
    const isBonusRedeemed = showBonus && stampCount > i;

    if (showBonus && filled) {
      return (
        <div className="flex items-center gap-[6px]">
          <div className="flex justify-center items-center w-[30px] h-[30px] rounded-full bg-white shadow-sm">
            <img src={pickImg} width={20} />
          </div>
          <span
            className={`ml-2 text-sm w-[60px] font-semibold ${
              isBonusRedeemed ? "line-through text-gray-400" : "text-white"
            }`}
          >
            {bonusText}
          </span>
        </div>
      );
    }

    // ❌ BONUS & NOT FILLED → bonus only with border
    if (showBonus && !filled) {
      return (
        <div className="flex items-center gap-[6px]">
          <div className="w-[30px] h-[30px] rounded-full bg-white shadow-sm" />
          <span
            className={`ml-2 w-[60px] text-sm font-semibold ${
              isBonusRedeemed ? "line-through text-gray-400 " : "text-white"
            }`}
          >
            {bonusText}
          </span>
        </div>
      );
    }

    // ✅ REGULAR STAMP FILLED → icon only
    if (filled) {
      return (
        <div className="flex justify-center items-center w-[30px] h-[30px] rounded-full bg-white shadow-sm">
          <img src={pickImg} width={20} />
        </div>
      );
    }

    // ❌ REGULAR EMPTY → empty white circle
    return (
      <div className="w-[30px] h-[30px] rounded-full bg-white shadow-sm" />
    );
  };

  const renderStampRow = (count, baseIndex = 0, bonus = null) => {
    return (
      <div className="w-full mx-auto mt-[5px] flex gap-[10px] justify-center ">
        {[...Array(count)].map((_, i) => {
          const currentIndex = baseIndex + i;
          const filled = stampCount > currentIndex;

          const showBonus = i === count - 1 && bonus !== null;

          return (
            <div key={i}>
              {renderStamp(currentIndex, filled, showBonus, bonus)}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      {numberOfStamps === 5 && (
        <>
          {renderStampRow(3, 0, bonus1)}
          {renderStampRow(2, 3, bonus2)}
        </>
      )}

      {numberOfStamps === 6 && (
        <>
          {renderStampRow(3, 0, bonus1)}
          {renderStampRow(3, 3, bonus2)}
        </>
      )}

      {numberOfStamps === 7 && (
        <>
          {renderStampRow(4, 0, bonus1)}
          {renderStampRow(3, 4, bonus2)}
        </>
      )}

      {numberOfStamps === 8 && (
        <>
          {renderStampRow(4, 0, bonus1)}
          {renderStampRow(4, 4, bonus2)}
        </>
      )}

      {numberOfStamps === 9 && (
        <>
          {renderStampRow(5, 0, bonus1)}
          {renderStampRow(4, 5, bonus2)}
        </>
      )}

      {numberOfStamps === 10 && (
        <>
          {renderStampRow(5, 0, bonus1)}
          {renderStampRow(5, 5, bonus2)}
        </>
      )}

      {numberOfStamps === 12 && (
        <>
          {renderStampRow(6, 0, bonus1)}
          {renderStampRow(6, 6, bonus2)}
        </>
      )}

      {numberOfStamps === 14 && (
        <>
          {renderStampRow(4, 0, bonus1)}
          {renderStampRow(3, 4, bonus2)}
          {renderStampRow(4, 7, bonus3)}
          {renderStampRow(3, 11, bonus4)}
        </>
      )}

      {numberOfStamps === 15 && (
        <>
          {renderStampRow(5, 0, bonus1)}
          {renderStampRow(5, 5, bonus2)}
          {renderStampRow(5, 10, bonus3)}
        </>
      )}

      {numberOfStamps === 16 && (
        <>
          {renderStampRow(4, 0, bonus1)}
          {renderStampRow(4, 4, bonus2)}
          {renderStampRow(4, 8, bonus3)}
          {renderStampRow(4, 12, bonus4)}
        </>
      )}

      {numberOfStamps === 20 && (
        <>
          {renderStampRow(5, 0, bonus1)}
          {renderStampRow(5, 5, bonus2)}
          {renderStampRow(5, 10, bonus3)}
          {renderStampRow(5, 15, bonus4)}
        </>
      )}
    </div>
  );
};

export default StampsTemplate;
